// Shared structured-data helper for hub pages.
// Hubs emit ONE JSON-LD @graph via pageSchemaScript(); this helper builds the
// ItemList node that goes into that graph. Breadcrumbs are handled by
// pageNode()/breadcrumbNode() in src/seo/schema.ts.

const SITE_ORIGIN = "https://arifkhanglobal.com";

export type HubItem = {
  name: string;
  /** Absolute or relative URL. Relative is resolved against the site origin. */
  url?: string;
  description?: string;
};

export type HubSchemaInput = {
  /** Hub path, e.g. "/solutions" — used for the ItemList @id. */
  hubPath: string;
  /** Display name for the ItemList (e.g. "Solutions by Arif Khan"). */
  listName: string;
  items: HubItem[];
};

function absolute(url: string | undefined): string | undefined {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  return `${SITE_ORIGIN}${url.startsWith("/") ? "" : "/"}${url}`;
}

/** ItemList node for a hub page, to be included in the page's @graph. */
export function hubItemListNode({ hubPath, listName, items }: HubSchemaInput) {
  return {
    "@type": "ItemList",
    "@id": `${SITE_ORIGIN}${hubPath}#list`,
    name: listName,
    numberOfItems: items.length,
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      ...(absolute(it.url) ? { url: absolute(it.url) } : {}),
      name: it.name,
      ...(it.description ? { description: it.description } : {}),
    })),
  };
}
